import React from 'react';
import { MessageSquare, ArrowRight, Check, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const LiveChatPage = () => {
  const { login } = useAuth();
  const features = ['Chat em tempo real', 'Transferência para humano', 'Histórico completo', 'Múltiplos atendentes'];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <MessageSquare className="h-4 w-4" />Live Chat
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Live Chat</span> integrado
              </h1>
              <p className="text-xl text-gray-600 mb-8">Quando o bot não consegue resolver, transfira para um atendente humano.</p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">Começar gratuitamente</Button>
            </div>
            <div className="bg-blue-50 rounded-3xl p-6">
              <div className="bg-white rounded-2xl p-4 shadow-sm">
                <div className="flex items-center gap-3 mb-4">
                  <Users className="h-6 w-6 text-[#3b82f6]" />
                  <div><span className="font-semibold">Atendentes online</span><span className="ml-2 text-green-500 text-sm">● 3 disponíveis</span></div>
                </div>
                <div className="space-y-2">
                  <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg"><div className="w-8 h-8 bg-[#3b82f6] rounded-full"></div><div><p className="text-sm font-medium">Ana</p><p className="text-xs text-gray-500">Atendendo 2 chats</p></div></div>
                  <div className="flex items-center gap-2 p-2 bg-gray-50 rounded-lg"><div className="w-8 h-8 bg-green-500 rounded-full"></div><div><p className="text-sm font-medium">Carlos</p><p className="text-xs text-gray-500">Disponível</p></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos do Live Chat</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((f) => (<div key={f} className="bg-white rounded-xl p-6 shadow-sm"><Check className="h-6 w-6 text-green-500 mb-3" /><p className="font-medium text-gray-900">{f}</p></div>))}
            </div>
          </div>
        </div>
        <div className="py-16"><div className="max-w-4xl mx-auto px-4"><Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white"><CardContent className="py-12 text-center"><h2 className="text-2xl font-bold mb-4">Combine bot + humanos</h2><Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">Começar agora <ArrowRight className="ml-2 h-4 w-4" /></Button></CardContent></Card></div></div>
      </main>
      <Footer />
    </div>
  );
};
export default LiveChatPage;
